//export const ServiceNow_base_URL = 'https://bdocantest.service-now.com/insighthub?id=sc_cat_item&sys_id=0a4eb77f470ea610b48e9681516d4386'

export enum Parm_Who_Need_Help_With
{
  REQUEST_ACCESS_TO_REPORT = 'Request%20Report%20Access',
  MODIFY_OR_DELETE_REPORT = 'Modify/Delete%20a%20Report',
  GOT_TECHNICAL_ISSUE = 'Got%20Technical%20Issues',
}

